import React from 'react';
import { Helmet } from 'react-helmet';
import NavBar from '../../components/layout/NavBar';
import Footer from '../../components/layout/Footer';
import './AboutUs.css';

const AboutUs = () => {
  const publicUrl = process.env.PUBLIC_URL || '';

  return (
    <div className="about-container">
      <Helmet>
        <title>About Us - Block Automation</title>
        <meta property="og:title" content="About Us - Block Automation" />
        <meta property="og:description" content="Learn about Block's team, purpose and mission." />
      </Helmet>
      
      <NavBar />
      
      {/* About Us Hero Section */}
      <div className="about-hero-section section-container">
        <div className="max-width">
          <div className="about-hero-content">
            <span className="about-label beforeHeading">ABOUT US</span>
            <h1 className="about-title">Meet Block Automation</h1>
            <p className="about-subtitle">
              We're passionate about protecting people from the sun's harmful rays while 
              promoting sustainable, innovative solutions for outdoor spaces.
            </p>
          </div>
          <div className="about-hero-image">
            <img 
              src="/logo_only_leaf.jpg" 
              alt="Block Automation Logo" 
            />
          </div>
        </div>
      </div>
      
      {/* Our Purpose Section - Now First */}
      <div className="about-purpose-section section-container">
        <div className="max-width">
          <div className="about-section-content">
            <div className="about-section-text">
              <h2 className="about-section-title">Our Purpose</h2>
              <p className="about-section-description">
                At Block, we believe that sun protection should be accessible and convenient for everyone. We believe people should be outside more, not less. 
                Our mission is to reduce the barriers to consistent sun protection by making high-quality 
                sunscreen available at the exact moment it's needed most.
              </p>
              <p className="about-section-description">
                We're committed to environmental sustainability, public health advancement, and forging 
                meaningful community partnerships that increase access to sun protection for underserved 
                populations.
              </p>
            </div>
            <div className="about-section-image">
              <img 
                src={`${publicUrl}/purpose_lq.jpg`} 
                alt="Block Purpose" 
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Our Story Section - New Middle Section */}
      <div className="about-story-section section-container">
        <div className="max-width">
          <div className="about-section-content reverse">
            <div className="about-section-text">
              <h2 className="about-section-title">Our Story</h2>
              <p className="about-section-description">
                We were founded in 2024 by Trevor and Johnny, two friends who both loved to be outside, but wanted to protect themselves from the sun.  We found that sunscreen was not always available when we needed it, and that it was expensive and inconvenient to carry around.  
                We discovered we were not alone, and that there was a need for a more accessible and convenient way to protect ourselves from the sun.
              </p>
              <p className="about-section-description">
                We combined our backgrounds in engineering, business, and health to create a 
                solution that addresses both practical needs and broader public health concerns.
              </p>
              <p className="about-section-description">
                What started as a concept for sunscreen dispensers at beaches has evolved into a 
                comprehensive approach to sun safety that includes innovative dispensing technology, 
                community partnerships, and educational initiatives.
              </p>
            </div>
            <div className="about-section-image">
              <img 
                src={`${publicUrl}/sunburn2.jpg`} 
                alt="Block Story" 
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Our Team Section - Now Last */}
      <div className="about-team-section section-container">
        <div className="max-width">
          <div className="about-section-content">
            <div className="about-section-text">
              <h2 className="about-section-title">Our Team</h2>
              <p className="about-section-description">
                We are on a mission to revolutionize sun protection. With combined experience at companies like Apple, Boston Dynamics and Bain & Company and cutting edge education at UPenn, Northwestern and Cornell, we're uniquely positioned to innovate and tackle the challenge of sun protection.
              </p>
             
            </div>
            <div className="about-section-team-profiles">
              <div className="team-members">
                <div className="team-member">
                  <div className="team-member-image">
                    <img 
                      src={`${publicUrl}/trevor.jpg`} 
                      alt="Trevor - Block Team" 
                      loading="lazy"
                    />
                  </div>
                  <h3 className="team-member-name">Trevor</h3>
                  <p className="team-member-title">Co-Founder & CEO</p>
                </div>
                <div className="team-member">
                  <div className="team-member-image">
                    <img 
                      src={`${publicUrl}/johnny.jpg`} 
                      alt="Johnny - Block Team" 
                      loading="lazy"
                    />
                  </div>
                  <h3 className="team-member-name">Johnny</h3>
                  <p className="team-member-title">Co-Founder & CTO</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Contact Section */}
      <div className="about-contact-section section-container">
        <div className="max-width">
          <h2 className="about-section-title centered">Contact Us</h2>
          <div className="about-contact-container">
            <div className="about-contact-card">
              <div className="contact-icon">
                <i className="email-icon"></i>
              </div>
              <h3>Email</h3>
              <p>trevor@blockautomation.com</p>
              <p>johnny@blockautomation.com</p>
            </div>
            
            <div className="about-contact-card">
              <div className="contact-icon">
                <i className="phone-icon"></i>
              </div>
              <h3>Phone</h3>
              <p>+1 (847) 612-5373</p>
              <p>Monday - Friday: 9am - 7pm PST</p>
            </div>
            
            <div className="about-contact-card">
              <div className="contact-icon">
                <i className="address-icon"></i>
              </div>
              <h3>Address</h3>
              <p>San Francisco, CA 94117</p>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default AboutUs;